import { callOperation } from "async-ops";
import { SAVE_DOCUMENT_EDIT_HISTORY } from "./save-document-edit-history";
import { INSERT_DOCUMENT_EVENT } from "./insert-document-event";

/**
 * Dual-writes a document lifecycle event (upload/edit/delete) to both history systems:
 * - SAVE_DOCUMENT_EDIT_HISTORY → [AUDIT].[DOCUMENT_CONTENT_HISTORY] (Document Edit History popup)
 * - INSERT_DOCUMENT_EVENT → public API audit log (External Audit History page)
 *
 * Both calls are fire-and-forget; failures are silently swallowed.
 */
export function logDocumentLifecycleEvent(
  documentId: number,
  changeType: string,
  eventName: string,
  attachedLevelName: string,
  attachedLevelId: number | null,
): void {
  callOperation(SAVE_DOCUMENT_EDIT_HISTORY, {
    documentId,
    changes: [{ changeType, deltaJson: "{}" }],
  }).catch(() => {});
  callOperation(INSERT_DOCUMENT_EVENT, {
    eventName,
    documentId,
    attachedLevelName,
    attachedLevelId,
  }).catch(() => {});
}
